const arrows = {
    down: '<path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/>',
    up: '<path d="M7 14l5-5 5 5z"/><path d="M0 0h24v24H0z" fill="none"/>',
};

function getButton(type) {
    return `<button class="vote-${type}">
  <div class="vote-container">
      <svg class="icon-arrow_drop_${type}" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          ${arrows[type]}
      </svg>
      <div class="number-container">
          <div class="number"></div>
          <div class="votes">Votes</div>
      </div>
  </div>
</button>`;
}

export function getUpDown() {
    return `<div class="vote--up_down">
  ${getButton("down")}
  ${getButton("up")}
</div>`;
}
